import TagManager from 'react-gtm-module';

export const trackSizeGuide = ({ linkText }: { linkText: string }) => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_name: 'click_size_guide_interaction',
      interaction: {
        interaction_location: 'PDP',
        link_text: linkText,
      },
    },
  });
};
